import { useState } from 'react';

export function Brand({ onNavigate }) {
  return <a className="mf-brand" href="/" onClick={onNavigate} aria-label="마켓핏 홈"><span className="mf-brand-mark" aria-hidden="true"><i /><i /><i /></span>marketfit<span className="mf-brand-ai">AI</span></a>;
}

export default function SiteHeader({ isServicesPage = false, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const sections = isServicesPage
    ? [{ href: '/', label: '홈으로' }, { href: '#united-ad', label: 'United Ad' }, { href: '#linkflow', label: 'LinkFlow' }]
    : [{ href: '#solutions', label: '솔루션' }, { href: '#how-it-works', label: '작동 방식' }, { href: '#technology', label: '핵심 기술' }, { href: '#faq', label: '자주 묻는 질문' }];

  const handleLink = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    setMenuOpen(false);
    const href = event.currentTarget.getAttribute('href');
    if (!href.startsWith('#')) {
      onNavigate?.(event);
      return;
    }
    const section = document.getElementById(href.slice(1));
    if (!section) return;
    event.preventDefault();
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${href}`);
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    section.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  return (
    <header className="mf-header">
      <div className="mf-container mf-header-inner">
        <Brand onNavigate={onNavigate} />
        <button type="button" className="mf-menu-toggle" aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'} aria-expanded={menuOpen} aria-controls="service-navigation" onClick={() => setMenuOpen(!menuOpen)}><span /><span /></button>
        <nav id="service-navigation" className={`mf-nav${menuOpen ? ' is-open' : ''}`} aria-label="서비스 메뉴">
          {sections.map((section) => <a key={section.href} href={section.href} onClick={handleLink}>{section.label}</a>)}
          <a className="mf-nav-services" href="/services" onClick={handleLink} aria-current={isServicesPage ? 'page' : undefined}>우리의 서비스 <span aria-hidden="true">↗</span></a>
        </nav>
      </div>
      <div className="mf-reading-progress" aria-hidden="true" />
    </header>
  );
}
